const tryParseJson = (value) => {
  if (typeof value !== "string") return null;
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
};

const asString = (value) => {
  if (!value) return "";
  if (typeof value === "string") return value;
  if (typeof value?.message === "string") return value.message;
  return "";
};

export const getServerMessage = (input, fallback = "Something went wrong") => {
  if (!input) return fallback;

  // Support passing either an Axios error, an API response body, or a string.
  const responseData = input?.response?.data;
  const data = responseData ?? input?.data ?? input;

  if (typeof data === "string") {
    const parsed = tryParseJson(data);
    return (
      asString(parsed?.data?.message) ||
      asString(parsed?.message) ||
      asString(parsed?.error_description) ||
      asString(parsed?.error) ||
      data ||
      fallback
    );
  }

  // Some backends proxy upstream errors like Auth0 under a nested `originalError.response.text`.
  const upstreamText =
    data?.originalError?.response?.text ??
    data?.data?.originalError?.response?.text ??
    input?.originalError?.response?.text ??
    input?.data?.originalError?.response?.text;
  if (typeof upstreamText === "string") {
    const parsed = tryParseJson(upstreamText);
    const upstreamMessage = asString(parsed?.message) || asString(parsed?.error);
    if (upstreamMessage) return upstreamMessage;
  }

  return (
    asString(data?.data?.message) ||
    asString(data?.message) ||
    asString(data?.errors?.[0]?.message) ||
    asString(data?.error_description) ||
    asString(data?.error) ||
    asString(input?.message) ||
    fallback
  );
};

